import React from "react";
import { Modal, FormControl } from "react-bootstrap";
import "./MedicineWiseBatchersSelect.css";
import Swal from "sweetalert2";
const MedicineWiseBatchersSelect = ({
  show,
  onHide,
  handleBatchNoEnter,
  handleBatchInputChange,
  handleReleaseQtyChange,
  setBatchInputRef,
  scannedBatchRows,
  batchScanSummary,
  totalRequestedQty,
  handleOnSubmit,
  getRole,
  editablePackSize,
  setEditablePackSize,
  pharmacyStock,
}) => {
  const rows =
    scannedBatchRows && scannedBatchRows.length > 0
      ? scannedBatchRows
      : [
          {
            batch_no: "",
            medicine_name: "",
            expiry_date: "",
            warehouse_stock: "",
            release_qty: "",
            isScannedBatch: false,
            isNotFifo: false,
          },
        ];

  // Validation: if requested - totalReleaseQty is 0, prevent further scanning
  const totalReleaseQty = rows.reduce(
    (sum, row) => sum + (Number(row.requested_qty) || 0),
    0,
  );
  const requested = Number(totalRequestedQty) || 0;
  const remainingToRelease = requested - totalReleaseQty;

  // Show popup if user tries to scan when remainingToRelease is 0
  const handleBatchNoEnterWrapper = async (event, index) => {
    const packSize = Number(editablePackSize) || 1;
    if (remainingToRelease < packSize) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title: `<div style='font-size:26px;font-weight:100;'>Cannot scan batch. Remaining quantity to release (${remainingToRelease}) is less than pack size (${packSize}).</div>`,
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    await handleBatchNoEnter(event, index);
  };
  const summary = batchScanSummary || {
    scannedBatch: "",
    medicineName: "",
    packSize: 0,
    warehouseTotalStock: 0,
  };

  const totalWarehouseStock = rows.reduce((sum, row) => {
    const warehouseStock = Number(row.warehouse_stock) || 0;
    const releaseQty = Number(row.release_qty) || 0;
    const remainingStock = Math.max(warehouseStock - releaseQty, 0);
    return sum + remainingStock;
  }, 0);

  const totalReleasedQty = rows.reduce(
    (sum, row) => sum + (Number(row.release_qty) || 0),
    0,
  );

  const baseWarehouseStock = Number(summary.warehouseTotalStock || 0);

  const displayedWarehouseStock =
    baseWarehouseStock > 0
      ? Math.max(baseWarehouseStock - totalReleasedQty, 0)
      : totalWarehouseStock;

  const hasWarehouseDeduction = rows.some(
    (row) => (Number(row.release_qty) || 0) > 0,
  );

  const hasValidScannedBatch = rows.some((row) => row.isScannedBatch);

  return (
    <Modal
      show={show}
      onHide={onHide}
      bsSize="lg"
      backdrop="static"
      dialogClassName="medicine-wise-batchers-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Release stock</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="stock-release-content">
          <div className="stock-release-fields">
            <div className="stock-release-field stock-release-scan">
              <label className="header-modal" htmlFor="release-batch">
                Scan batch
              </label>
              <FormControl
                type="text"
                id="release-batch"
                name="batch_no"
                placeholder="Scan Batch No"
                inputRef={(el) => setBatchInputRef(el, 0)}
                value={summary.scannedBatch || ""}
                onChange={(e) => {
                  if (e.target.value.trimStart().startsWith("-")) {
                    e.target.value = summary.scannedBatch || "";
                    return;
                  }
                  handleBatchInputChange(e, 0);
                }}
                onKeyDown={(e) => handleBatchNoEnterWrapper(e, 0)}
                style={{ height: "48px", fontSize: "16px" }}
                disabled={remainingToRelease <= 0}
              />
            </div>
            <div className="stock-release-field stock-release-medicine">
              <label className="header-modal" htmlFor="release-medicine">
                Medicine
              </label>
              <FormControl
                type="text"
                id="release-medicine"
                name="medicine_name"
                value={`${summary.medicineName || ""}${summary.itemCode ? ` (${summary.itemCode})` : ""}`}
                readOnly
                className="medicine-name-style"
              />
            </div>
            <div className="stock-release-field">
              <label className="header-modal" htmlFor="release-warehouse">
                Warehouse stock
              </label>
              <FormControl
                type="text"
                id="release-warehouse"
                name="warehouse_stock"
                value={displayedWarehouseStock}
                onWheel={(e) => e.target.blur()}
                readOnly
                style={{
                  color: "black",
                  fontWeight: "800",
                  height: "48px",
                  fontSize: "16px",
                  border: hasWarehouseDeduction ? "2px solid red" : "",
                  backgroundColor: hasWarehouseDeduction
                    ? "rgb(255, 191, 168)"
                    : "",
                }}
              />
            </div>
            <div className="stock-release-field">
              <label className="header-modal" htmlFor="release-pack">
                Pack size
              </label>
              <FormControl
                type="text"
                id="release-pack"
                name="pack_size"
                inputMode="numeric"
                pattern="[0-9]*"
                value={editablePackSize}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[0-9]*$/.test(value)) {
                    setEditablePackSize(value);
                  } else {
                    e.target.value =
                      editablePackSize == null ? "" : editablePackSize;
                  }
                }}
                style={{
                  color: "black",
                  fontWeight: "800",
                  height: "48px",
                  fontSize: "16px",
                }}
              />
            </div>
            <div className="stock-release-field">
              <label className="header-modal" htmlFor="release-requested">
                Requested stock remaining
              </label>
              <FormControl
                type="text"
                id="release-requested"
                name="warehouse_stock"
                value={(() => {
                  // Use requested_qty from parent (totalRequestedQty), only deduct released qty
                  const requested = Number(totalRequestedQty) || 0;
                  const totalReleaseQty = rows.reduce(
                    (sum, row) => sum + (Number(row.release_qty) || 0),
                    0,
                  );
                  return requested - totalReleaseQty;
                })()}
                readOnly
                className="paren-request-total-stock-style"
                style={(() => {
                  const totalReleaseQty = rows.reduce(
                    (sum, row) => sum + (Number(row.release_qty) || 0),
                    0,
                  );
                  if (totalReleaseQty > 0) {
                    return {
                      border: "2px solid red",
                      backgroundColor: "rgb(255, 191, 168)",
                    };
                  }
                  return {};
                })()}
              />
              <p className="Request-Total-Stock-style">
                Pharmacy stock: {pharmacyStock || 0}
              </p>
            </div>
            {!hasValidScannedBatch && (
              <div className="stock-release-field">
                <div className="header-modal">Release stock</div>
                {rows.map((row, index) =>
                  (() => {
                    const warehouseStock = Number(row.warehouse_stock) || 0;
                    return (
                      <FormControl
                        key={index}
                        aria-label="Release stock"
                        placeholder="0"
                        style={{
                          fontWeight: "800",
                          fontSize: "16px",
                          color: row.release_qty ? " black" : "black",
                          border: row.release_qty
                            ? "2px solid rgb(80, 181, 87)"
                            : "",
                          backgroundColor: row.release_qty
                            ? "rgb(229, 255, 232)"
                            : "",
                          textAlign: "center",
                          marginBottom: "4px",
                        }}
                        type="number"
                        min="0"
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key))
                            e.preventDefault();
                        }}
                        max={Math.max(
                          0,
                          Math.min(
                            warehouseStock,
                            requested -
                              totalReleasedQty +
                              (Number(row.release_qty) || 0),
                          ),
                        )}
                        value={row.release_qty == null ? "" : row.release_qty}
                        onChange={(e) => handleReleaseQtyChange(e, index)}
                      />
                    );
                  })(),
                )}
              </div>
            )}
          </div>

          {hasValidScannedBatch && (
            <div style={{ overflowX: "auto" }}>
              <div>
                <hr className="vertical-line-alignment" />
              </div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0 10px",
                }}
              >
                <thead>
                  <tr>
                    <th className="batch-text-field">batch number</th>
                    <th className="batch-text-field">Medicine name</th>
                    <th className="batch-text-field">Expiry Date</th>
                    <th
                      className="batch-text-field"
                      style={{ width: "205px", textAlign: "left" }}
                    >
                      wareHouse Stock
                    </th>
                    <th className="batch-text-field">Release Stock</th>
                    <th className="batch-text-field"></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) =>
                    (() => {
                      const warehouseStock = Number(row.warehouse_stock) || 0;
                      const releaseQty = Number(row.release_qty) || 0;
                      const remainingStock = Math.max(
                        warehouseStock - releaseQty,
                        0,
                      );

                      return (
                        <tr
                          key={index}
                          style={
                            row.isScannedBatch
                              ? {
                                  borderRadius: "10px",
                                  backgroundColor: "#fff3cd",
                                }
                              : undefined
                          }
                        >
                          <td className="batch-padding-style">
                            {row.batch_no || ""}
                          </td>
                          <td className="batch-padding-style">
                            {row.medicine_name || ""}
                          </td>
                          <td className="remaining-warehouse-stock-td-style">
                            {row.expiry_date || ""}
                          </td>
                          <td className="remaining-warehouse-stock-td-style">
                            <FormControl
                              style={{
                                border: row.release_qty ? " 2px solid red" : "",
                                backgroundColor: row.release_qty
                                  ? " rgb(255, 191, 168"
                                  : "",
                                color: row.release_qty ? " black" : "black",
                                fontWeight: "800",
                                fontSize: "16px",
                                textAlign: "center",
                                width: "150px",
                              }}
                              type="number"
                              value={remainingStock}
                              name="warehouse_stock"
                            />
                          </td>
                          <td className="release-qty-td-style">
                            <FormControl
                              style={{
                                fontWeight: "800",
                                fontSize: "16px",
                                color: row.release_qty ? " black" : "black",
                                border: row.release_qty
                                  ? "2px solid rgb(80, 181, 87)"
                                  : "",
                                backgroundColor: row.release_qty
                                  ? "rgb(229, 255, 232)"
                                  : "",
                                textAlign: "center",
                              }}
                              type="number"
                              min="0"
                              onKeyDown={(e) => {
                                if (["-", "+", "e", "E"].includes(e.key))
                                  e.preventDefault();
                              }}
                              max={Math.max(
                                0,
                                Math.min(
                                  warehouseStock,
                                  requested -
                                    totalReleasedQty +
                                    (Number(row.release_qty) || 0),
                                ),
                              )}
                              value={
                                row.release_qty == null ? "" : row.release_qty
                              }
                              onChange={(e) => handleReleaseQtyChange(e, index)}
                            />
                          </td>
                          <td></td>
                          {/* <td
                            style={{
                              padding: "8px 12px",
                              color: "#333",
                              fontWeight: "600",
                            }}
                          >
                            {row.isScannedBatch ? "FIFO" : " ⚠ Not FIFO"}
                          </td> */}
                          {/* <td
                            style={{
                              padding: "8px 12px",
                              color: "#333",
                              fontWeight: "600",
                            }}
                          >
                            {(() => {
                              // Only show FIFO/Not FIFO for the scanned batch
                              if (!row.isScannedBatch) return "";
                              // Find the earliest expiry date among all rows
                              const parseDate = (d) => {
                                if (!d) return null;
                                // Accepts YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss
                                const parts = d.split("T")[0].split("-");
                                if (parts.length === 3) {
                                  return new Date(
                                    Number(parts[0]),
                                    Number(parts[1]) - 1,
                                    Number(parts[2]),
                                  );
                                }
                                return null;
                              };
                              const allDates = rows
                                .map((r) => parseDate(r.expiry_date))
                                .filter(Boolean);
                              if (allDates.length === 0) return "";
                              const minDate = new Date(
                                Math.min(...allDates.map((d) => d.getTime())),
                              );
                              const thisDate = parseDate(row.expiry_date);
                              if (!thisDate) return "";
                              // Compare year, month, day
                              if (
                                thisDate.getFullYear() ===
                                  minDate.getFullYear() &&
                                thisDate.getMonth() === minDate.getMonth() &&
                                thisDate.getDate() === minDate.getDate()
                              ) {
                                return "FIFO";
                              } else {
                                return "⚠ Not FIFO";
                              }
                            })()}
                          </td> */}
                          <td
                            style={{
                              padding: "8px 12px",
                              color: "#ff6b4a",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            {(() => {
                              if (!row.isScannedBatch) return "";

                              const parseDate = (d) =>
                                d
                                  ? new Date(d.split("T")[0] + "T00:00:00")
                                  : null;
                              const validDates = rows
                                .map((r) => parseDate(r.expiry_date))
                                .filter(Boolean);
                              if (!validDates.length) return "";
                              const minTime = Math.min(
                                ...validDates.map((d) => d.getTime()),
                              );
                              const thisDate = parseDate(row.expiry_date);
                              if (!thisDate) return "";
                              return thisDate.getTime() === minTime
                                ? "FIFO"
                                : "⚠ Not FIFO";
                            })()}
                          </td>
                        </tr>
                      );
                    })(),
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-danger" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={handleOnSubmit}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MedicineWiseBatchersSelect;
